<mat-drawer-container fullscreen>
  <mat-drawer #drawer mode="side"> </mat-drawer>
  <mat-progress-spinner *ngIf="loading" [mode]="'indeterminate'"
    style="margin: auto; position: fixed; top: 0; bottom: 0; left: 0; right: 0;"> </mat-progress-spinner>
  <router-outlet></router-outlet>
</mat-drawer-container>